import FoundationIcon from "@mui/icons-material/Foundation";
import { Box, Button, InputAdornment, Typography } from "@mui/material";
import { useFormik } from "formik";
import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import CustomInput from "../../components/CustomInput";
import { UserContext } from "../../context/userContext";
import { AuthDetails } from "../../model";
import { UserLoginInfo } from "../../types/context";
import { appLogger, Http } from "../../utils";
import { withSnackbar } from "../../utils/common/SnackbarHoc";
import { roleConfig } from "../../utils/config/role-config";
const initialValues = {
  organisationName: "",
};

const validationSchema = Yup.object({
  // organisationName: Yup.string().required("Organisation Name is required"),
  organisationName: Yup.string()
    .required("Organisation Name is required")
    .matches(
      /^[a-zA-Z0-9@]+$/,
      "This field cannot contain white space and special characters"
    ),
});

const OrganisationForm = (props: any) => {
  const { email, setIsOrgCompleted } = props;
  const [organisationVisible, setorganisationVisible] = useState(false);
  const [organisationNameVisible, setorganisationNameVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { userInfo, setUserInfo } = useContext(UserContext) as UserLoginInfo;
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: async (values) => {
      try {
        submitOrganisationFormRequest(userInfo, values);
      } catch (error) {
        appLogger.error({
          errObj: {
            method: "onSubmit",
            component: "home",
            fileName: "OrganisationForm.tsx",
            err: error,
          },
        });
      }
    },
  });

  const handleRole = (userDetails: any) => {
    for (const key in roleConfig) {
      if (userDetails.userRole == roleConfig[key]) {
        return key;
      }
    }
  };

  const handleOrgUserSignin = async () => {
    Http.get({
      url: `/api/v2/users/login`,
      // state: userStateVariable,
    })
      .then((response: any) => {
        if (response) {
          appLogger.info({
            infoObj: {
              method: "handleOrgUserSignin",
              component: "home",
              fileName: "OrganisationForm.tsx",
              response: response,
            },
          });
          props.snackbarShowMessage("Login Successfully", "success");
          if (response.userDetails.userRole.length > 0) {
            response.userDetails.userRole =
              handleRole(response.userDetails) || "";
          }
          const obj: AuthDetails = {
            isAuthenticated: true,
            idToken: userInfo.idToken,
            accessToken: userInfo.accessToken,
            userDetails: response.userDetails,
            isSsoUser: false,
          };
          setUserInfo(obj);
          setIsLoading(false);
          if (
            response &&
            response.userDetails &&
            response.userDetails &&
            response.userDetails.orgId &&
            response.userDetails.orgId != ""
          ) {
            localStorage.setItem("userOrgId", response.userDetails.orgId);
            navigate("/dashboard");
          }
        }
      })
      .catch((error: any) => {
        setIsLoading(false);
        appLogger.error({
          errObj: {
            method: "handleOrgUserSignin",
            component: "home",
            fileName: "OrganisationForm.tsx",
            err: error,
          },
        });
      });
  };

  const submitOrganisationFormRequest = async (userInfo: any, values: any) => {
    const postData = {
      name: values.organisationName || "",
    };
    setIsLoading(true);
    Http.post({
      url: `/api/v2/organizations`,
      body: {
        ...postData,
      },
      state: userInfo,
    })
      .then((response: any) => {
        if (response && response.message && response.message.length > 0) {
          formik.setErrors({
            organisationName:
              "Organisation with the given name already exists. Please contact your administrator to join this organisation. You may alternatively register with a different organisation name.",
          });
          setIsLoading(false);
        } else {
          handleOrgUserSignin();
        }
        //   setIsLoading(false);
        //   props.snackbarShowMessage(
        //     "organization created successfully",
        //     "success",
        //     3000
        //   );
      })
      .catch((error: any) => {
        appLogger.error({
          errObj: {
            method: "submitOrganisationFormRequest",
            component: "home",
            fileName: "OrganisationForm.tsx",
            err: error,
          },
        });
        setIsLoading(false);
        props.snackbarShowMessage(error.message, "error");
      });
    // if (!validateOrganisationForms(OrganisationForm, organisationNameForm)) {
    // 	setLoading(false);
    // 	return;
    // }
    // Auth.completeOrganisationForm(user, organisationId, { email: email })
    //   .then((newUser: any) => {
    //     if (
    //       newUser &&
    //       newUser.signInUserSession.idToken &&
    //       newUser.signInUserSession.accessToken
    //     ) {

    //       // setLoading(false);
    //       handleSignIn(newUser);
    //     } else {
    //       // notifyError('Set organisationId failed. Please try again');
    //       // setLoading(false);
    //     }
    //   })
    //   .catch((error: any) => {
    //     // notifyError(e.message);
    //     // setLoading(false);
    //   });
  };

  const handleClickShoworganisation = () => {
    setorganisationVisible(!organisationVisible);
  };

  const handleorganisationName = () => {
    setorganisationNameVisible(!organisationNameVisible);
  };

  return (
    <Box className={isLoading ? "form-wrap loader" : "form-wrap"}>
      <Typography sx={{ mt: 1, mb: 1 }}>
        Create Your Organisation With CuVo
      </Typography>
      {/* <Typography className="intro-question-label" sx={{ mb: 1, fontSize: 13 }} >
                Enter your organisation details below:
            </Typography> */}
      <Box
        component="form"
        onSubmit={formik.handleSubmit}
        method="post"
        noValidate
        sx={{ mt: "20px" }}
      >
        {/* <FormHelperText id='outlined-weight-helper-text'>
					Weight
					</FormHelperText> */}

        <CustomInput
          placeholder="Organisation Name"
          label="Organisation Name"
          id="organisationName"
          startAdornment={
            <InputAdornment position="start">
              <FoundationIcon />
            </InputAdornment>
          }
          {...formik.getFieldProps("organisationName")}
          error={
            formik.touched.organisationName && formik.errors.organisationName
              ? true
              : false
          }
          helperText={
            formik.touched.organisationName && formik.errors.organisationName
              ? formik.errors.organisationName
              : null
          }
        />

        <Button
          type="submit"
          fullWidth
          variant="contained"
          sx={{
            mt: "15px",
            mb: "15px",
            backgroundColor: (theme: any) => theme.palette.primary.main,
            textTransform: "uppercase",
          }}
        >
          Continue
        </Button>
      </Box>
    </Box>
  );
};

export default withSnackbar(OrganisationForm);
